import { render, staticRenderFns } from "./folders-important.vue?vue&type=template&id=28281827&scoped=true"
import script from "./folders-important.vue?vue&type=script&lang=js"
export * from "./folders-important.vue?vue&type=script&lang=js"
import style0 from "./folders-important.vue?vue&type=style&index=0&id=28281827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28281827",
  null
  
)

export default component.exports